/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Error_GenericInputs */



/**
* | output |
* | --- |
* | "Something went wrong. Please try again." |
*
* @param {Assistant_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_error_generic = /** @type {((inputs?: Assistant_Error_GenericInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Error_GenericInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une erreur s'est produite. Veuillez réessayer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si è verificato un errore. Riprova.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Произошла ошибка. Пожалуйста, попробуйте еще раз.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Algo salió mal. Por favor, inténtalo de nuevo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出错了，请重试。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エラーが発生しました。もう一度お試しください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुछ गड़बड़ हुई है। कृपया दोबारा प्रयास करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Algo deu errado. Por favor, tente novamente.")
	return /** @type {LocalizedString} */ ("Something went wrong. Please try again.")
});